/* -------------------------------------------------------------------------------------------------
   <auto-generated>
      This code was generated from a T4 template.

      DO NOT ALTER!
      Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.

      Template Authors: Leonard Lewis
   </auto-generated>
   ------------------------------------------------------------------------------------------------- */

/// <summary>
///   Metrics.EvaluationContext_
///   This is an auto-generated enumeration of the SWFC_Learning.Metrics.EvaluationContext domain table...
/// </summary>
import { IDomainModel } from './domain-model.interface';

export enum EvaluationContext_ {
   /// <summary>
   ///   Content Item-based (content)
   /// </summary>
   ContentItem = 1,
   /// <summary>
   ///   Lesson (comprehensive) (lesson)
   /// </summary>
   Lesson = 2,
   /// <summary>
   ///   Module (comprehensive) (module)
   /// </summary>
   Module = 3
}

export const EvaluationContexts: EvaluationContext[] = [
   {
      code: EvaluationContext_.ContentItem,
      literal: 'ContentItem',
      description: 'Content Item-based',
      shortDescription: 'content',
      listPriority: 0,

      typeName: "EvaluationContext"
   },
   {
      code: EvaluationContext_.Lesson,
      literal: 'Lesson',
      description: 'Lesson (comprehensive)',
      shortDescription: 'lesson',
      listPriority: 0,

      typeName: "EvaluationContext"
   },
   {
      code: EvaluationContext_.Module,
      literal: 'Module',
      description: 'Module (comprehensive)',
      shortDescription: 'module',
      listPriority: 0,

      typeName: "EvaluationContext"
   }
]

export class EvaluationContext implements IDomainModel {
   code: EvaluationContext_
   literal: string
   description: string
   shortDescription: string
   listPriority: number

   typeName: string

   static toDomainModel(code: EvaluationContext_): EvaluationContext {
      return EvaluationContexts.find(d => d.code === code)
   }
}
